import React from 'react';
import CommunityHandlePage from 'components/community-handle-page/CommunityHandlePage';
import SpaceDetailsModal from 'components/space-details-modal/SpaceDetailsModal';
import { Suspense } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import JamDetailsModal from 'components/jam-details-modal/JamDetailsModal';

export default function CommunityHandleSpaceDetails() {
  const { handle, id } = useParams<{ handle: string; id?: string }>();
  const history = useHistory();
  return (
    <>
      <CommunityHandlePage />
      {id && (
        <Suspense fallback={null}>
          <JamDetailsModal
            onClose={() => {
              history.push(`/@${handle}`);
            }}
          />
        </Suspense>
      )}
    </>
  );
}
